import { GeneralInformation } from "../../constants/aquafina";
import { RangeIterator, FormatDate } from "../../utils";
import { CoverageRow, NotProvidedRow } from "../table/rows";
import { CoverageCell } from "../table/cells";

import CollapsableSection from "./collapsable-section";

type GeneralInfoProps = {
  data: GeneralInformation[];
  hideNetworkProviderName?: boolean;
  cellColSpan?: number;
};

const PolicyGeneralInfo = ({
  data,
  hideNetworkProviderName = false,
  cellColSpan = 1,
}: GeneralInfoProps) => (
  <CollapsableSection
    numberOfColumns={data.length * cellColSpan}
    title="General Information"
    hasSeparator={false}
  >
    <PolicyGeneralInfoData
      data={data}
      hideNetworkProviderName={hideNetworkProviderName}
      cellColSpan={cellColSpan}
    />
  </CollapsableSection>
);

const PolicyGeneralInfoData = ({
  data,
  hideNetworkProviderName = false,
  cellColSpan = 1,
}: GeneralInfoProps) => {
  if (data.every((d) => d === null)) {
    return <NotProvidedRow colSpan={data.length * cellColSpan} />;
  }

  let hideFundingType = true;
  let hideNetwork = true;

  for (let i = 0; i < data.length; i++) {
    if (!hideNetworkProviderName) {
      if (data[i].networkProvider != null && data[i].networkProvider !== "") {
        hideNetwork = false;
      }
    }

    if (data[i].fundingType != null && data[i].fundingType !== "") {
      hideFundingType = false;
    }
  }

  return (
    <>
      <CoverageRow label="Original Effective Date" isWhite={true}>
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={FormatDate(data[index]?.originalEffectiveDate)}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      <CoverageRow label="Most Recent Effective Date">
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={FormatDate(data[index].mostRecentEffectiveDate)}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      <CoverageRow label="Renewal Date" isWhite={true}>
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={FormatDate(data[index].renewalDate)}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      {!hideFundingType && (
        <CoverageRow label="Funding Type">
          {RangeIterator(data.length, (index) => (
            <CoverageCell
              value={data[index].fundingType}
              key={index}
              colSpan={cellColSpan}
            />
          ))}
        </CoverageRow>
      )}
      <CoverageRow
        label="Benefit Eligibility Classes"
        isWhite={!hideFundingType}
      >
        {RangeIterator(data.length, (index) => (
          <CoverageCell
            value={data[index].benefitClasses}
            key={index}
            colSpan={cellColSpan}
          />
        ))}
      </CoverageRow>
      {!hideNetwork && (
        <CoverageRow label="Plan Network" isWhite={hideFundingType}>
          {RangeIterator(data.length, (index) => (
            <CoverageCell
              value={data[index].networkProvider}
              key={index}
              colSpan={cellColSpan}
            />
          ))}
        </CoverageRow>
      )}
    </>
  );
};

export default PolicyGeneralInfo;
